import { SUPPORTED_REGIONS } from '../../../shared/enums';

export const getAir3MenuCta = (regional, isMobile) => {
  const isUsDesktop = regional === SUPPORTED_REGIONS.US && !isMobile;
  return isUsDesktop ? 'Order Now' : 'Preorder Now';
};
